import React, {
  createContext, useContext, useMemo, useState,
} from 'react'

interface HeaderVisibilityContextType {
  isHeaderVisible: boolean
  setIsHeaderVisible: (visible: boolean) => void
}

const HeaderVisibilityContext = createContext<
  HeaderVisibilityContextType | undefined
>(undefined)

export function HeaderVisibilityProvider({ children }: {
  children: React.ReactNode
}) {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true)

  const visibilityProps = useMemo(
    () => ({
      isHeaderVisible,
      setIsHeaderVisible,
    }),
    [isHeaderVisible, setIsHeaderVisible],
  )

  return (
    <HeaderVisibilityContext.Provider value={visibilityProps}>
      {children}
    </HeaderVisibilityContext.Provider>
  )
}

export function useHeaderVisibility() {
  const context = useContext(HeaderVisibilityContext)
  if (context === undefined) {
    throw new Error(
      'useHeaderVisibility must be used within a HeaderVisibilityProvider',
    )
  }
  return context
}
